/*
 * Copyright (c) 2026, FusionAuth, All Rights Reserved
 */

// Layout-level concerns (elements, sidenav, alert dismiss) are handled by
// the shared layout.ts entrypoint, which tm.ftl loads on every TM page.
// Only page-specific logic belongs here.
import { addSignals } from '../../services/signals/SignalService';

addSignals(document.querySelector('form fieldset') as HTMLElement);
